import FormAlert from './Alert';
import FormContainer from './Container';
import FormEmailInput from './EmailInput';
import FormHeading from './Heading';
import FormLoginMethods from './LoginMethods';
import FormPasswordInput from './PasswordInput';
import FormPasswordStrengthMeter from './PasswordStrengthMeter';
import FormSamlLoginButton from './SamlLoginButton';
import FormSubmitButton from './SubmitButton';
import FormTermsLink from './TermsLink';

//  Export each piece, which can then be used like <AuthForm.SubComponent>
export default {
  Container: FormContainer,
  Heading: FormHeading,
  Alert: FormAlert,
  EmailInput: FormEmailInput,
  PasswordInput: FormPasswordInput,
  PasswordStrengthMeter: FormPasswordStrengthMeter,
  SubmitButton: FormSubmitButton,
  TermsLink: FormTermsLink,
  LoginMethods: FormLoginMethods,
  SamlLoginButton: FormSamlLoginButton,
};
